<template>
  <button @click="click()">
    {{label}}
    <v-icon :large="large" class="mb-1">{{ icon }}</v-icon>
  </button>
</template>

<script>
export default {
  props: {
    icon: String,
    label: String,
    large: {type: Boolean, default: false}
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
button {
  padding: 0rem 0.3rem;
  background: #efefef;
  border: none;
  border-radius: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.1rem;
  text-align: center;
  outline: none;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
button:hover {
  box-shadow: -2px -2px 6px rgba(255, 255, 255, .6),
              -2px -2px 4px rgba(255, 255, 255, .4),
              2px 2px 2px rgba(255, 255, 255, .05),
              2px 2px 4px rgba(0, 0, 0, .1);
}
button:active {
  box-shadow: inset -2px -2px 6px rgba(255, 255, 255, .7),
              inset -2px -2px 4px rgba(255, 255, 255, .5),
              inset 2px 2px 2px rgba(255, 255, 255, .075),
              inset 2px 2px 4px rgba(0, 0, 0, .15);
}
</style>